module.exports = __webpack_public_path__ + "img/db.6886bec6.png";